/* ============================================================
   LIKIRI — comportements (galerie, accordéons, quantité, sticky)
   Chaque section s'initialise indépendamment : on peut poser
   plusieurs sections LIKIRI sur la même page sans conflit.
   ============================================================ */
(function () {
  'use strict';

  function initGallery(root) {
    var gallery = root.querySelector('[data-lk-gallery]');
    if (!gallery || gallery.dataset.lkReady) return;
    gallery.dataset.lkReady = '1';

    var slides = gallery.querySelectorAll('[data-lk-slide]');
    var thumbs = root.querySelectorAll('[data-lk-thumb]');
    var counter = gallery.querySelector('[data-lk-counter]');
    if (!slides.length) return;
    var idx = 0;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('is-active', s === idx);
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === idx);
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    for (var t = 0; t < thumbs.length; t++) {
      (function (i) {
        thumbs[i].addEventListener('click', function () { go(i); });
      })(t);
    }
    var prev = gallery.querySelector('[data-lk-prev]');
    var next = gallery.querySelector('[data-lk-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    var x0 = null;
    gallery.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(dx < 0 ? idx + 1 : idx - 1);
      x0 = null;
    }, { passive: true });
  }

  function initAccordions(root) {
    var heads = root.querySelectorAll('[data-lk-acc] .lk-acc__head');
    for (var h = 0; h < heads.length; h++) {
      if (heads[h].dataset.lkReady) continue;
      heads[h].dataset.lkReady = '1';
      heads[h].addEventListener('click', function () {
        var item = this.parentNode;
        var group = item.parentNode;
        var open = item.classList.contains('is-open');
        var sibs = group.querySelectorAll('.lk-acc__item');
        for (var s = 0; s < sibs.length; s++) sibs[s].classList.remove('is-open');
        if (!open) item.classList.add('is-open');
      });
    }
  }

  function initQty(root) {
    var boxes = root.querySelectorAll('[data-lk-qty]');
    for (var b = 0; b < boxes.length; b++) {
      (function (box) {
        if (box.dataset.lkReady) return;
        box.dataset.lkReady = '1';
        var input = box.querySelector('[data-lk-qty-input]');
        var minus = box.querySelector('[data-lk-qty-minus]');
        var plus = box.querySelector('[data-lk-qty-plus]');
        function set(n) {
          n = Math.max(1, Math.min(99, isNaN(n) ? 1 : n));
          input.value = n;
          var label = box.querySelector('[data-lk-qty-val]');
          if (label) label.textContent = n;
        }
        if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
        if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
        if (input) input.addEventListener('change', function () { set(parseInt(input.value, 10)); });
      })(boxes[b]);
    }
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-lk-sticky]');
    var buybox = root.querySelector('[data-lk-buybox]');
    if (!sticky || !buybox || sticky.dataset.lkReady) return;
    sticky.dataset.lkReady = '1';

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0, rootMargin: '0px 0px -85% 0px' });
      io.observe(buybox);
    } else {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('is-visible', buybox.getBoundingClientRect().bottom < 0);
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.likiri-page');
    for (var i = 0; i < roots.length; i++) {
      initGallery(roots[i]);
      initAccordions(roots[i]);
      initQty(roots[i]);
      initSticky(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Réinitialisation dans l'éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();